<template>
  <div>
    <div class="index-module_articleWrap_2Zphx">
      <div class="zhemo">做好价值投资的三大要点</div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">抓住消费和新能源这两大方向</span></p>
        <!--26--><!--27--><!--28--><!--29--><!--30--><!--31-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >12月28日周一，沪深两市继续上攻，白酒板块再次大涨，其他的消费板块比如说沉寂已久的乳业板块也迎来了上涨的机会，新能源汽车继续表现。整体来看，市场的赚钱效应依然集中在消费和新能源这两大方向，这也是我一直以来建议大家重点关注的两大方向。属于受益于经济转型，并且未来成长比较确定的方向，因此不断的受到资金的追捧，迎来了比较好的赚钱效应。</span
          >
        </p>
        <!--32--><!--33--><!--34--><!--35--><!--36--><!--37-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >一些基差股，题材股则是不断的被边缘化，不断的下跌。一方面我们看到近期市场里面的白酒、医药、新能源等方向的一些龙头股，股价不断创出历史新高。另一方面有140只个股股价创出历史新低。可以说一部分股票创新高，另一部分股票创新低，高下立现，这就体现出价值投资的魅力。价值投资是被事实证明能够从长期战胜市场的一种投资理念，它不是空洞的理论。</span
          >
        </p>
        <!--38--><!--39--><!--40--><!--41--><!--42--><!--43-->
      </div>
      <div class="index-module_textWrap_3ygOc szhuang">
        <p><span class="bjh-p">价值投资的三个方面</span></p>
        <!--44--><!--45--><!--46--><!--47--><!--48--><!--49-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >巴菲特作为价值投资最伟大的实践者，确实获得了投资的奇迹，也成为唯一一个通过做股票投资成为世界首富的人。但价值投资并不是只有资金量大才能做，事实上无论资金量大小，无论你在哪个市场，都是适用的。有很多人说在A股市场不适合价值投资，那是因为对价值投资的误解。价值投资的核心，我把它总结为以下。</span
          >
        </p>
        <!--50--><!--51--><!--52--><!--53--><!--54--><!--55-->
      </div>
      <div class="index-module_textWrap_3ygOc szhuang">
        <p>
          <span class="bjh-p"
            >第一个方面就是巴菲特说的名言：如果你不把股票仅仅当成股票，是当成股东证的话，你就离价值投资不远了。我们把投资股票看做是一门生意，看作是这个企业的股东，这样我们就会持有一些优质的股票，不会去持有那些垃圾股票，我们会做好公司的股东，不去垃圾股的股东。</span
          >
        </p>
        <!--56--><!--57--><!--58--><!--59--><!--60--><!--61-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >吴敬琏老先生曾经写过“要做股东不要做股民”。其实在英语里面股东和股民是同一个词，“share
            holder”。因此这篇文章如果翻译成英文，那是让人很困惑的，“要做share
            holder，不要做 share
            holder”，这是为什么呢？因为在A股市场才分成股东和股民，股东一般是指一些大的机构投资者，股民则是散户投资者。</span
          >
        </p>
        <!--62--><!--63--><!--64--><!--65--><!--66--><!--67-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我们要用股东的心态，不要用股民的心态去看投资，这样我们才能真正地抓住好的机会，才能像滚雪球一样，实现财富不断地增长，我们才会选择具有护城河的好企业来进行投资，不是炒消息、炒概念。</span
          >
        </p>
        <!--68--><!--69--><!--70--><!--71--><!--72--><!--73-->
      </div>
      <div class="index-module_textWrap_3ygOc szhuang">
        <p>
          <span class="bjh-p"
            >价值投资的第二点就是我们投资的公司要有价值，这是最根本的。如果你投资公司没有价值，你持有的时间越长，亏得越多。当然有价值不是说它一定市盈率低，不一定指价值股，好的成长股也有价值。比如我们投资于消费行业，投资于白酒，医药这些龙头，我们就不能仅仅看它的市盈率。事实上，只看市盈率是很多散户亏钱的根源。</span
          >
        </p>
        <!--74--><!--75--><!--76--><!--77--><!--78--><!--79-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >市盈率适用的范围其实很窄，它只适用于一些没有品牌价值的工业企业，我们要看重这个企业给我们带来的财务上的回报，也就是净资产回报率ROE。要看这个公司多少年能收回投资，也就是看市盈率。但对于有品牌价值的消费品，我们就不能仅仅看它的财务汇报，我们还要看它的品牌价值。打个比方大家就明白了，就好像你投资北上广深一线城市的房产，有多少人是看中租金收益率？深圳房子的租金收益率2％都不到，租金收益率颠倒过来就是房价的市盈率，超过了50倍。</span
          >
        </p>
        <!--80--><!--81--><!--82--><!--83--><!--84--><!--85-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我们会看到很多投资房产的人，甚至不装修，也不出租，就是空着等待房价上涨，因为他们看重的是房价上涨的潜力，也就是所谓的资本利得，不是看重分红收益率。因此投资房产并不看市盈率，为什么你投资一些有品牌价值的消费品，就去看市盈率呢？</span
          >
        </p>
        <!--86--><!--87--><!--88--><!--89--><!--90--><!--91-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >因此我们对于价值投资要有深刻的理解，不要浮于表面。比如对于成长股，像新能源汽车，去年我就提出新能源汽车替代传统燃油车是大势所趋。现在新能源汽车的渗透率只有3％，将来会从3％提高到2025年的20％，最终提高到100％，这将是多少倍的增长空间？</span
          >
        </p>
        <!--92--><!--93--><!--94--><!--95--><!--96--><!--97-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >我们现在去看这些新能源汽车的股票就不能按它当年的业绩来算它的市盈率，应该按十年以后这些企业进入到成熟期，估计他们十年以后的利润再计算市盈率才是合理的。这是对成长股的估值，也就是不能看当年的业绩，要看十年以后的业绩，这是我给大家提出的最新的一个观念，让大家改变对于成长股的一些固执误区。</span
          >
        </p>
        <!--98--><!--99--><!--100--><!--101--><!--102--><!--103-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >很多投资者喜欢买一些低市盈率的股票，几年前就有很多人选择买低估值的银行股，钢铁股，结果几年下来估值还是低，机会成本很大，浪费了投资白龙马的机会，陷入了市盈率的误区。做价值投资，买有价值的股票并不是只买价值股或者是买低估值的股票，而是买有未来成长空间的股票，因为做投资买的是未来。</span
          >
        </p>
        <!--104--><!--105--><!--106--><!--107--><!--108--><!--109-->
      </div>
      <div class="index-module_textWrap_3ygOc szhuang">
        <p>
          <span class="bjh-p"
            >价值投资的第三点是安全边际，巴菲特说股灾是上帝送给价值投资者的礼物，但往往在市场大跌时，很多投资者已经不敢买股票了。当你心仪的股票跌下来之后，你敢不敢买其实是考验你是不是坚定的价值投资者。你敢于在下跌时买入或者持有的原动力来自于对上市公司基本面的了解，你对公司的信心。只有你真的对股票有信心，你才会真正的去买入。如果公司是一个你没有深入研究了解的公司，在大跌时你是不敢买入的。</span
          >
        </p>
        <!--110--><!--111--><!--112--><!--113--><!--114--><!--115-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >当然一般情况之下，如果不发生股灾，好的公司不可能便宜，也就很难有安全边际。因此对于价值投资者来说并不害怕股灾，反而是欢迎股灾。因为只有股灾时，你才能以便宜的价格，以有安全边际的价格买入你心仪的股票。上面就是我给大家讲的价值投资的正确理念，正确的理解价值投资你才能抓住市场机会。</span
          >
        </p>
        <!--116--><!--117--><!--118--><!--119--><!--120--><!--121-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p><span class="bjh-p">抓住A股市场黄金十年的机会</span></p>
        <!--122--><!--123--><!--124--><!--125--><!--126--><!--127-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >从2016年起，我四次到美国奥马哈参加巴菲特股东大会，第一时间将巴菲特的价值投资理念介绍给A股投资者。这几年下来价值投资已经逐渐成为最主流的投资理念，也有越来越多的投资者加入我的价值投资圈。做价值投资，做好公司的股东或者买入优质基金才能抓住A股市场黄金十年的机会。</span
          >
        </p>
        <!--128--><!--129--><!--130--><!--131--><!--132--><!--133-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >2021年，A股市场还会继续呈现出结构分化的行情，业绩优良的股票还会继续创新高，差的股票还会继续下跌。现在新证券法已经正式实施，刑法修正案大幅提升了财务造假以及财务欺诈的违法成本，取消了对个人最高罚六十万的上限。将一些重大违法违规，重大欺诈的个人的刑法期限最高提高到十五年，这将会大大地震慑不法分子，打击那些试图通过财务造假，或者利润操作来控制股价的行为，对于欺诈发行更是严厉的打击。</span
          >
        </p>
        <!--134--><!--135--><!--136--><!--137--><!--138--><!--139-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >严刑峻法是保障A股市场长期健康发展的一个基础，也是全面推行注册制的一个法律保障，A股市场也将因此走向成熟。新证券法将全面推行注册制，退市新规，严格推行退市制度，</span
          >
        </p>
        <!--140--><!--141--><!--142--><!--143--><!--144--><!--145-->
      </div>
      <div class="index-module_textWrap_3ygOc">
        <p>
          <span class="bjh-p"
            >宪法修正案，严厉打击这种违法行为。未来A股市场的黄金十年就要靠这些完善的法律法规，完善的制度来保驾护航。A股市场也会更加成熟，更具有可投资性，真正的保护中小投资者利益。</span
          >
        </p>
        <!--146--><!--147--><!--148--><!--149--><!--150--><!--151-->
      </div>
      <p class="free">（来源：财富动力网）</p>
      <!--13--><!--152--><!--153-->
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>